/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Import_DescriptionInputs */



/**
* | output |
* | --- |
* | "Import a project from a file and configure import settings" |
*
* @param {Project_Import_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_import_description = /** @type {((inputs?: Project_Import_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Import_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer un projet depuis un fichier et configurer les paramètres d’importation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importieren Sie ein Projekt aus einer Datei und konfigurieren Sie die Importeinstellungen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa un progetto da un file e configura le impostazioni di importazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импортируйте проект из файла и настройте параметры импорта.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar un proyecto desde un archivo y configurar los ajustes de importación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从文件导入项目并配置导入设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルからプロジェクトをインポートし、インポート設定を構成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("किसी फ़ाइल से प्रोजेक्ट आयात करें और आयात सेटिंग्स कॉन्फ़िगर करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importe um projeto a partir de um arquivo e configure as opções de importação.")
	return /** @type {LocalizedString} */ ("Import a project from a file and configure import settings")
});